module.exports = __webpack_public_path__ + "img/home.c44cd468.gif";